import {makeActionCreator} from '../../redux-toolbelt';

export const setJustAddedDishToShoppingCart = makeActionCreator<'setJustAddedDishToShoppingCart', boolean>(
  'setJustAddedDishToShoppingCart',
);
